import { render, staticRenderFns } from "./FechamentoDia.vue?vue&type=template&id=61236039&"
import script from "./FechamentoDia.vue?vue&type=script&lang=js&"
export * from "./FechamentoDia.vue?vue&type=script&lang=js&"
import style0 from "./FechamentoDia.vue?vue&type=style&index=0&id=61236039&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports